import { Snowflake, Wind, Refrigerator, Home } from "lucide-react";

export type Service = {
  id: string;
  title: string;
  short: string;
  long: string;
  icon: typeof Snowflake;
  image: string;
  residential: string[];
  commercial: string[];
};

export const SERVICES: Service[] = [
  {
    id: "heat-pumps",
    title: "Heat Pumps",
    short: "Efficient heating and cooling for warm, dry homes year-round.",
    long: "Heat pumps are the most efficient way to heat and cool a New Zealand home. We design, install and service systems sized exactly to your space, with a strong focus on quiet, low-running-cost units that last.",
    icon: Snowflake,
    image: "/images/services/heat-pumps.png",
    residential: [
      "Single split heat pumps",
      "Multi-split systems",
      "Ducted central heat pumps",
      "Replacements & upgrades",
      "Servicing & maintenance",
    ],
    commercial: [
      "Office heating & cooling",
      "Retail & hospitality",
      "Light commercial multi-splits",
    ],
  },
  {
    id: "air-conditioning",
    title: "Air Conditioning",
    short: "Reliable cooling for homes, offices, hotels, bars and more.",
    long: "From a single bedroom unit through to multi-zone commercial fit-outs, we supply and install air conditioning solutions that match your space, your usage pattern, and your budget.",
    icon: Wind,
    image: "/images/services/air-conditioning.png",
    residential: [
      "Bedroom & living-area units",
      "Whole-of-home multi-splits",
      "After-installation servicing",
    ],
    commercial: [
      "Apartment complexes",
      "Hotels & motels",
      "Bars & restaurants",
      "Office systems",
      "Retail",
    ],
  },
  {
    id: "refrigeration",
    title: "Refrigeration",
    short: "Commercial fridge and freezer repairs, line work and installation.",
    long: "Whether it's a single seal replacement or a full walk-in chiller for a hospitality fit-out, our refrigeration team keeps food safe, energy bills sensible, and downtime to a minimum.",
    icon: Refrigerator,
    image: "/images/services/refrigeration.png",
    residential: [
      "Fridge door seal replacement",
      "Compressor replacement",
    ],
    commercial: [
      "Refrigeration line repairs",
      "Retail refrigeration",
      "Food storage systems",
      "Walk-in chillers",
    ],
  },
  {
    id: "home-ventilation",
    title: "Home Ventilation",
    short: "Positive pressure, balanced and energy-recovery systems for healthier homes.",
    long: "Northland homes work hard against humidity. We install ventilation systems that move stale, damp air out and bring fresh, filtered air in, reducing condensation, mould and respiratory triggers.",
    icon: Home,
    image: "/images/services/home-ventilation.png",
    residential: [
      "SmartVent positive pressure systems",
      "Balanced pressure systems",
      "Energy recovery ventilation (ERV)",
      "Mould & moisture control",
    ],
    commercial: [
      "Commercial ventilation upgrades",
      "Mechanical ventilation maintenance",
    ],
  },
];
